import { RefObject, useCallback } from 'react'

export const useScrollToSelf = <T extends HTMLElement>(ref: RefObject<T | null>) => {
  const handleScrollToSelf = useCallback(() => {
    if (ref.current) {
      ref.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      })
    }
  }, [ref])

  return handleScrollToSelf
}
